export default __webpack_public_path__ + "img/4e033a745327fdf1fbe9e6e4b9f94080.png";